import React, { Component } from "react";
import AntdComment, {CommentProps} from 'antd/lib/comment';
import 'antd/lib/comment/style';

export default class Comment extends Component<CommentProps> {
    render() {
        const { content, ...restProps } = this.props;
        return (
          <AntdComment content={content} {...restProps} />
        )
    }
}



// WEBPACK FOOTER //
// ./src/components/comment/index.tsx